import React, { useState } from "react";
import PageBackButton from "../../components/PageBackButton";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { WidthWrapper } from "../../components/SignUpLoginForgot/LoginStyledComponents";
import OTPfield from "../../components/OTPfield";
import Button from "../../components/Button";
import { Colors, Text } from "../../config";
import ImgHeaderSubheader from "../../components/SignUpLoginForgot/ImgHeaderSubheader";
import { changePin } from "../../services/userServices";
import ErrorModal from "../../components/ErrorSuccessModal/ErrorModal";
import ErrorSuccessModal from "../../components/ErrorSuccessModal";
import { useLoaderContext } from "../../contexts/loaderContext";

const nextIcon = require("../../assets/images/Arrow_Right.png");
const changePinIcon = require("../../assets/images/change-pin-frame.png");

const ChangePin = () => {
  const navigate = useNavigate();
  const [oldPin, setOldPin] = useState("");
  const [newPin, setNewPin] = useState("");
  const [showOldPin, setShowOldPin] = useState(true);
  const [showNewPin, setShowNewPin] = useState(false);
  const buttonDisabled = newPin.length < 4 || oldPin.length < 4;
  const [backendErrorMsg, setBackendErrorMsg] = useState(false);
  const [successMsg, setSuccessMsg] = useState(false);
  const { setLoader } = useLoaderContext();

  const handleResetPin = () => {
    if (newPin === oldPin) {
      setBackendErrorMsg(Text.newPinOldPin);
    } else {
      const changePinData = {
        currentPin: oldPin,
        newPin: newPin,
      };
      postChangePin(changePinData);
    }
  };

  const postChangePin = async (changePinData) => {
    console.log(changePinData);
    setLoader(true);
    try {
      const response = await changePin(changePinData);
      console.log(response);
      if (response.status === 200) {
        setLoader(false);
        setSuccessMsg(Text.pinChangeSuccessLogin);
      }
    } catch (error) {
      setLoader(false);
      console.log(error);
      setBackendErrorMsg(error.message);
    }
  };

  const closeErrorModal = () => {
    setBackendErrorMsg(false);
  };

  const closeSuccessModal = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("employeeData");
    localStorage.removeItem("firebaseEmployeeToken");
    navigate("/auth/login");
  };

  return (
    <ChangePinContainer>
      <PageBackButton
        handleClick={() => navigate("/user/dashboard")}
        label={Text.changePin}
      />
      <LeftRightWrapper>
        <ContentWrapper>
          <WidthWrapper maxWidth="23rem">
            <ImgHeaderSubheader
              header={Text.updateYourPin}
              subheader={Text.stayOneStepAhead}
            />
          </WidthWrapper>
          <OTPWrapper>
            <OTPfield
              label={Text.enterOldPin}
              uniqueName="pinOldChange"
              getEnteredOTP={setOldPin}
              hiddenNeeded
              showHideOTP={showOldPin}
              setShowHideOTP={() => setShowOldPin(!showOldPin)}
              autoFocus
            />
            <OTPfield
              label={Text.enterNewPin}
              uniqueName="pinNewChange"
              getEnteredOTP={setNewPin}
              hiddenNeeded
              showHideOTP={showNewPin}
              setShowHideOTP={() => setShowNewPin(!showNewPin)}
            />
          </OTPWrapper>
          <ButtonWrapper>
            <Button
              label={Text.changePin}
              onClick={handleResetPin}
              rightImgSrc={nextIcon}
              fontColor={Colors.white}
              fontSize="1.375rem"
              fontWeight="700"
              bgColor={Colors.pomegranate}
              topBottomPadding="0.75rem"
              labelImgGap="0.5rem"
              disabled={buttonDisabled}
            />
          </ButtonWrapper>
        </ContentWrapper>
        <ImageWrapper>
          <ChangePinImg src={changePinIcon} alt="change PIN" />
        </ImageWrapper>
      </LeftRightWrapper>
      {backendErrorMsg && (
        <ErrorModal
          subheaderText={backendErrorMsg}
          setClose={closeErrorModal}
          onButtonClick={closeErrorModal}
        />
      )}
      {successMsg && (
        <ErrorSuccessModal
          headerText={Text.success}
          subheaderText={successMsg}
          setClose={closeSuccessModal}
          buttonText="OK"
          onButtonClick={closeSuccessModal}
        />
      )}
    </ChangePinContainer>
  );
};

export default ChangePin;

const ChangePinContainer = styled.div`
  margin: 2rem 2rem 0;
`;
const LeftRightWrapper = styled.div`
  display: flex;
  height: 70vh;
  margin-top: 2rem;
  gap: 3rem;
`;
const ContentWrapper = styled.div`
  width: 45%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 5rem;
  @media only screen and (max-width: 1000px) {
    width: 100%;
  }
  @media only screen and (max-height: 900px) {
    gap: 3.5rem;
  }
  @media only screen and (max-height: 768px) {
    gap: 2rem;
  }
`;
const ImageWrapper = styled.div`
  width: 55%;
  background: ${Colors.blackHaze};
  border-radius: 0.75rem;
  display: flex;
  align-items: center;
  @media only screen and (max-height: 900px) {
    justify-content: center;
  }
  @media only screen and (max-width: 1000px) {
    display: none;
  }
`;
const ButtonWrapper = styled.div`
  width: 100%;
  max-width: 22.5rem;
`;
const OTPWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  margin-left: 4rem;
  @media only screen and (max-width: 500px) {
    margin-left: 0rem;
  }
`;
const ChangePinImg = styled.img`
  height: auto;
  max-width: 100%;
  @media only screen and (max-height: 900px) {
    max-height: 100%;
    width: auto;
  }
`;
